import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=d13f8b5e&scoped=true&"
import script from "./Leader.vue?vue&type=script&lang=js&"
export * from "./Leader.vue?vue&type=script&lang=js&"
import style0 from "./Leader.vue?vue&type=style&index=0&id=d13f8b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13f8b5e",
  null
  
)

export default component.exports